export default "__VITE_ASSET__BrgFJKpQ__"